/**
 * WAV 编码器：将 Float32 采样数据编码为标准 16-bit PCM WAV 文件
 * 参考 luyin.html 中的 WavEncoder 实现
 */
export class WavEncoder {
  private sampleRate: number;
  private numChannels: number;
  private samples: number[] = [];

  constructor(sampleRate: number, numChannels = 1) {
    this.sampleRate = sampleRate;
    this.numChannels = numChannels;
  }

  addSamples(floatArray: Float32Array) {
    this.samples.push(...floatArray);
  }

  encode(): Blob {
    const sampleCount = this.samples.length;
    const buffer = new ArrayBuffer(44 + sampleCount * 2);
    const view = new DataView(buffer);

    // RIFF chunk
    this.writeString(view, 0, "RIFF");
    view.setUint32(4, 36 + sampleCount * 2, true);
    this.writeString(view, 8, "WAVE");

    // fmt chunk
    this.writeString(view, 12, "fmt ");
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true); // PCM
    view.setUint16(22, this.numChannels, true);
    view.setUint32(24, this.sampleRate, true);
    view.setUint32(28, this.sampleRate * this.numChannels * 2, true);
    view.setUint16(32, this.numChannels * 2, true);
    view.setUint16(34, 16, true); // 16-bit

    // data chunk
    this.writeString(view, 36, "data");
    view.setUint32(40, sampleCount * 2, true);

    // 写入样本数据 (float -> 16-bit PCM)
    let offset = 44;
    for (let i = 0; i < sampleCount; i++) {
      let sample = Math.max(-1, Math.min(1, this.samples[i]));
      sample = sample < 0 ? sample * 0x8000 : sample * 0x7FFF;
      view.setInt16(offset, sample, true);
      offset += 2;
    }

    return new Blob([buffer], { type: "audio/wav" });
  }

  private writeString(view: DataView, offset: number, string: string) {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  }
}
